import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { InitiativeState, Initiative } from '@models/index'

const initialState: InitiativeState = {
  initiatives: [],
  filters: {
    status: [],
    assignee: [],
  },
  selectedInitiativeId: null,
  loading: false,
  error: null,
}

const initiativesSlice = createSlice({
  name: 'initiatives',
  initialState,
  reducers: {
    setInitiatives: (state, action: PayloadAction<Initiative[]>) => {
      state.initiatives = action.payload
    },
    addInitiative: (state, action: PayloadAction<Initiative>) => {
      state.initiatives.push(action.payload)
    },
    updateInitiative: (state, action: PayloadAction<Initiative>) => {
      const index = state.initiatives.findIndex((i) => i.id === action.payload.id)
      if (index !== -1) {
        state.initiatives[index] = action.payload
      }
    },
    removeInitiative: (state, action: PayloadAction<string>) => {
      state.initiatives = state.initiatives.filter((i) => i.id !== action.payload)
    },
    setSelectedInitiative: (state, action: PayloadAction<string | null>) => {
      state.selectedInitiativeId = action.payload
    },
    setStatusFilter: (state, action: PayloadAction<string[]>) => {
      state.filters.status = action.payload
    },
    setAssigneeFilter: (state, action: PayloadAction<string[]>) => {
      state.filters.assignee = action.payload
    },
  },
})

export const {
  setInitiatives,
  addInitiative,
  updateInitiative,
  removeInitiative,
  setSelectedInitiative,
  setStatusFilter,
  setAssigneeFilter,
} = initiativesSlice.actions
export default initiativesSlice.reducer
